var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsBoolean, IsEmail, IsEnum, IsOptional, IsString, IsUUID } from 'class-validator';
import { Role } from '../../roles/index.js';
export class BackendInvitedUserDto {
    userId;
    email;
    firstName;
    lastName;
    role;
    officeId;
    officeLocationId;
    testBackendMode;
    /** The fixtures' and the challenge's own account: activated at once, no invite mail. */
    testAccount;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "userId", void 0);
__decorate([
    IsEmail(),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "email", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "firstName", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "lastName", void 0);
__decorate([
    IsEnum(Role),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "role", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "officeId", void 0);
__decorate([
    IsOptional(),
    IsUUID('4'),
    Expose(),
    __metadata("design:type", String)
], BackendInvitedUserDto.prototype, "officeLocationId", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], BackendInvitedUserDto.prototype, "testBackendMode", void 0);
__decorate([
    IsOptional(),
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], BackendInvitedUserDto.prototype, "testAccount", void 0);
//# sourceMappingURL=backend-invited-user.dto.js.map